import { ReactElement, ReactNode } from "react";
import { Button, Center, Modal, Stack, useMantineTheme } from "@mantine/core";
import ModalTitle from "@common/components/thirdParty/mantine/modal/ModalTitle";

export interface IAddOnConfirmModalProps {
  testId: string;
  opened: boolean;
  title: string;
  icon?: ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  danger?: boolean;
  children: ReactNode;
  onClose(save?: boolean): void;
}

export function AddOnConfirmModal({
  testId,
  opened,
  title,
  icon,
  confirmLabel,
  cancelLabel = "Cancel",
  danger = false,
  children,
  onClose,
}: IAddOnConfirmModalProps): ReactElement {
  const theme = useMantineTheme();

  return (
    <Modal
      data-testid={testId}
      centered
      onClose={() => onClose()}
      opened={opened}
      overflow="inside"
      padding={2 * theme.spacing.md}
      size="md"
      title={<ModalTitle>{title}</ModalTitle>}
    >
      <Stack spacing="xl">
        {icon && <Center>{icon}</Center>}

        {children}

        {/*pb to prevent the scrollbar appearing during the button animation*/}
        <Stack spacing="sm" pb="1px">
          <Button
            color={danger ? "red" : undefined}
            onClick={() => onClose(true)}
          >
            {confirmLabel}
          </Button>

          <Button variant="outline" onClick={() => onClose()}>
            {cancelLabel}
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
}
